module.exports = __webpack_public_path__ + "text-message.png?40c0c7d7eea4a08c9b7a377cdebedf63";